import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { BrandCampaignCategory } from "../../../shared/models/brandCampaignCategory";
import { BrandService } from "../../../shared/services/api/brand.service";
import { HttpClient } from "../../../shared/services/http-client";

@Injectable()
export class BrandCampaignCategoryService {
  constructor(
    private http: HttpClient,
    private brandService: BrandService,
  ) {}

  createCategory(
    campaignId: number,
    detailsId: number,
    category: BrandCampaignCategory,
  ): Observable<BrandCampaignCategory> {
    const brandId = this.brandService.currentBrandId;

    return this.http
      .post(
        `brand/${brandId}/campaign/${campaignId}/detail/${detailsId}/category`,
        JSON.stringify(category),
      )
      .pipe(map(({ body }) => new BrandCampaignCategory(body)));
  }

  public updateCategory(
    campaignId: number,
    detailsId: number,
    category: BrandCampaignCategory,
  ): Observable<BrandCampaignCategory> {
    const brandId = this.brandService.currentBrandId;

    return this.http
      .put(
        `brand/${brandId}/campaign/${campaignId}/detail/${detailsId}/category/${category.id}`,
        JSON.stringify(category),
      )
      .pipe(map(({ body }) => new BrandCampaignCategory(body)));
  }

  public deleteCategory(
    campaignId: number,
    detailsId: number,
    categoryId: number,
  ): Observable<boolean> {
    const brandId = this.brandService.currentBrandId;

    return this.http
      .del(
        `brand/${brandId}/campaign/${campaignId}/detail/${detailsId}/category/${categoryId}`,
      )
      .pipe(map(({ body }) => body));
  }
}
